import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import authHelpers from './AuthHelpers';

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={(props) => (
        authHelpers.isAuthenticated()
          ? <Component {...props} />
          : <Redirect to='/login' />
      )} />
)


export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/components/auth/PrivateRoute.js